import type { AxiosRequestConfig } from "axios";
import { axiosInstance } from "@/src/api/axiosInstance";
import type { ApiRequestConfig, ApiResponseDto, HttpMethod } from "@/src/types/api.types";

async function request<T>(
  method: HttpMethod,
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig & ApiRequestConfig,
): Promise<T> {
  const response = await axiosInstance.request<ApiResponseDto<T>>({
    method,
    url,
    data,
    ...config,
    skipAuth: config?.skipAuth,
    skipGlobalErrorHandler: config?.skipGlobalErrorHandler,
    tokenHeader: config?.tokenHeader,
    suppressUnauthorizedRedirect: config?.suppressUnauthorizedRedirect,
  } as AxiosRequestConfig & ApiRequestConfig);

  return response.data.data;
}

export const apiClient = {
  get: <T>(url: string, config?: AxiosRequestConfig & ApiRequestConfig) =>
    request<T>("GET", url, undefined, config),
  post: <T>(url: string, data?: unknown, config?: AxiosRequestConfig & ApiRequestConfig) =>
    request<T>("POST", url, data, config),
  put: <T>(url: string, data?: unknown, config?: AxiosRequestConfig & ApiRequestConfig) =>
    request<T>("PUT", url, data, config),
  patch: <T>(url: string, data?: unknown, config?: AxiosRequestConfig & ApiRequestConfig) =>
    request<T>("PATCH", url, data, config),
  delete: <T>(url: string, config?: AxiosRequestConfig & ApiRequestConfig) =>
    request<T>("DELETE", url, undefined, config),
};
